import { render, staticRenderFns } from "./navigation-breadcrumb.vue?vue&type=template&id=2cff5bb5&scoped=true"
import script from "./navigation-breadcrumb.vue?vue&type=script&lang=js"
export * from "./navigation-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./navigation-breadcrumb.vue?vue&type=style&index=0&id=2cff5bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff5bb5",
  null
  
)

export default component.exports